import React from "react";

const STYLES = {
  in_stock: "bg-green-600/90 text-white",
  low_stock: "bg-amber-500 text-black",
  out_of_stock: "bg-red-600 text-white",
};
const LABELS = { in_stock: "In Stock", low_stock: "Low Stock", out_of_stock: "Out of Stock" };

export default function StockBadge({ status, productId, className = "" }) {
  if (!STYLES[status]) return null; // untracked products show no badge
  return (
    <span
      data-testid={`stock-badge-${status}-${productId}`}
      className={`inline-block text-[10px] font-mono-alt tracking-widest uppercase px-2 py-1 ${STYLES[status]} ${className}`}
    >
      {LABELS[status]}
    </span>
  );
}
